import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";
import MaterialTable from "material-table";
import DataService from "../../../../../Service";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { ThemeProvider } from "@material-ui/styles";
import { createMuiTheme } from "@material-ui/core/styles";
import HeaderMenu from "../../../../../Components/HeaderMenu";
import { useHistory, use } from "react-router";
import { AddCircleOutlined } from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import Loader from "../../../../../Components/Loader";
import useDebounce from "../../../../../Components/debounce";
import { useDispatch } from "react-redux";
import SaveAlt from "@material-ui/icons/SaveAlt";
import { forwardRef } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { DELETE_STEPPER_DATA } from "../../../../../Redux/actions";
import { ResetOrganisationDetails } from "../Create/OrganisationDetails/OrganisationDetailsActions";
import { ResetActivity } from "../Create/Activity/OrganisationActivityActions";
import { ResetContact } from "../Create/Contact/OrganisationContactActions";
import { ResetContract } from "../Create/Contract/OrganisationContractActions";
import { ResetGeneral } from "../Create/General/OrganisationGeneralActions";
import { ResetBusinessDevelopment } from "../Create/OrganisationBusinessDevelopment/OrganisationBusinessDevelopmentActions";
import { ResetPreContract } from "../Create/PreContract/OrganisationPreContractActions";
import { ResetProfile } from "../Create/Profile/OrganisationProfileActions";
import Popper from "@material-ui/core/Popper";
import InputBase from "@material-ui/core/InputBase";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import SearchByCategory from "../../../../../Components/category_based_search";
import { TooltipWrapper } from "../../../../../Common/Utils/common_utils";
import ExportSelector from "../../../Organization/ManageInfo/ExportSelector";
import { CircularProgress, IconButton, Tooltip } from "@material-ui/core";
import { showSnackbar } from "../../../../../Components/Snackbar/SnackbarActions";
import TableChartOutlinedIcon from "@material-ui/icons/TableChartOutlined";

export default function OrganisationList() {
  const history = useHistory();
  const dispatch = useDispatch();

  const useStyles = makeStyles((theme) => ({
    rotateLink: {
      transform: "rotate(-26deg)",
    },
    wrapper: {
      backgroundColor: "#fff",
      borderRadius: "4px",
      padding: theme.spacing(1, 2),
      border: "1px solid #d5d5d5",
      marginLeft: "73px",
      marginBottom: "30px",
      paddingLeft: "2px",
      paddingTop: "3px",
      paddingBottom: "8px",
      width: "32%",
      height: "40px",
    },
    divider: {
      margin: "8px 0",
    },
    filters: {
      padding: "10px 24px",
      "& .filter": {
        paddingRight: theme.spacing(3),
      },
    },
    miTable: {
      "& .MuiToolbar-root": {
        "& .material-icons": {
          color: theme.palette.secondary.main,
        },
      },
      "& .MuiTableHead-root": {
        "& .MuiTableCell-head": {
          "& span": {
            color: "#077F83",
          },
        },
      },
      "& .MuiTableBody-root": {
        "& .MuiTableCell-body": {
          padding: "10px 16px",
          lineHeight: "1.50",
          color: "#4A4A4A !important",
          "& .MuiIconButton-root": {
            padding: "0px 16px",
          },
        },
      },
    },
  }));

  const createOrganisationListLayout = {
    width: "90%",
    margin: "0 auto",
    // marginTop: "80px",
  };

  // const theme = createMuiTheme({
  //   overrides: {
  //     // MuiToolbar: {
  //     //   root: {
  //     //     backgroundColor: "#f1eded",
  //     //   },
  //     // },
  //     MuiTableCell: {
  //       root: {
  //         fontSize: "16px",
  //         fontFamily: "Open Sans"
  //       }
  //     },
  //     MUIDataTablePagination: {
  //       tableCellContainer: {
  //         padding: "0px",
  //       },
  //       navContainer: {
  //         backgroundColor: "#f1eded",
  //       },
  //     },
  //     MUIDataTableHeadCell: {
  //       fixedHeader: {
  //         backgroundColor: "#f1eded",
  //       }
  //     }
  //   },
  // });

  const classes = useStyles();
  const [apiData, setApiData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [searchTextSelect, handleSearchText] = useState(null);
  const debouncedSearchText = useDebounce(searchTextSelect, 700);
  const anchorRef = React.useRef(null);
  const [open, setOpen] = useState(false);

  const getData = () => {
    setLoading(true);
    const params = {
      page: page + 1 || 1,
      count_per_page: pageSize || 20,
      search_keyword: debouncedSearchText || null,
    };
    DataService.getDirectData(`/organisations`, params)
      .then((response) => {
        let listData = response["organisations"];
        setApiData(listData);
        console.log(listData);
        setTotalCount(response.total_count);
        setLoading(false);
      })
      .catch((err) => {});
  };

  useEffect(() => {
    setLoading(true);
    getData();
  }, [debouncedSearchText]);
  const columns = [
    {
      field: "id",
      title: "ID",
      export: true,
      hidden: true,
      notExportable: true,
    },
    {
      field: "organisation_name",
      title: "Name",
      headerStyle: {
        textAlign: "left",
        padding: "10px 26px",
        color: " #077F83",
      },
      cellStyle: {
        textAlign: "left",
        padding: "10px 26px",
      },
    },
    {
      field: "internal_status",
      title: "Internal status",
      headerStyle: {
        textAlign: "left",
        padding: "10px 26px",
        color: " #077F83",
      },
      cellStyle: {
        textAlign: "left",
        padding: "10px 26px",
      },
    },
    {
      field: "coaching_coordinators",
      title: "Coaching coordinator",
      headerStyle: {
        textAlign: "left",
        padding: "10px 26px",
        color: " #077F83",
      },
      cellStyle: {
        textAlign: "left",
        padding: "10px 26px",
      },
      render: (rowData) => (
        <span>
          {rowData?.coaching_coordinators?.length
            ? rowData?.coaching_coordinators.join(",  ")
            : "-"}
        </span>
      ),
    },
    {
      // title: 'Actions',
      headerStyle: {
        textAlign: "right",
        padding: "10px 26px",
      },
      cellStyle: {
        textAlign: "right",
        paddingRight: "40px",
      },
      notExportable: true,
      render: (rowData) => (
        <Button
          disableElevation
          variant="outlined"
          color="#F1ECED"
          size="small"
          onClick={() => {
            history.push({
              pathname: `/admin/organisation/${rowData.id}`,
              state: { orgName: rowData.organisation_name },
            });
          }}
          style={{
            backgroundColor: "#008080",
            color: "#fff",
            textTransform: "none",
          }}
        >
          View
        </Button>
      ),
    },
    {
      notExportable: true,
      render: (rowData) => {
        return (
          <Tooltip
            title={
              <TooltipWrapper
                text={
                  isDownloadIndividual.isLoading &&
                  isDownloadIndividual.downloadingOption === rowData.id
                    ? `Downloading ${rowData.organisation_name} records`
                    : `Download ${rowData.organisation_name} records`
                }
              />
            }
          >
            <IconButton
              onClick={(event) => {
                handleDownloadIndividual(rowData);
              }}
              disabled={
                isDownloadIndividual.isLoading &&
                isDownloadIndividual.downloadingOption !== rowData.id
              }
            >
              {isDownloadIndividual.isLoading &&
              isDownloadIndividual.downloadingOption === rowData.id ? (
                <CircularProgress size={20} color="secondary" />
              ) : (
                <SaveAlt style={{ height: "01.5rem" }} color="secondary" />
              )}
            </IconButton>
          </Tooltip>
        );
      },
    },
  ];

  const options = {
    exportButton: false,
    search: false,
    exportFileName: "organisation_list",
    emptyRowsWhenPaging: false,
    exportDelimiter: ",",
    searchFieldAlignment: "right",
    total: totalCount,
    exportAllData: true,

    headerStyle: {
      fontWeight: 800,
      color: "#077F83",
      position: "sticky",
      top: "0",
    },
    maxBodyHeight: "600px",
    pageSizeOptions: [20, 50, 75, 100],
    page: page,
    pageSize: pageSize,
  };
  const tableIcons = {
    Export: forwardRef((props, ref) => (
      <SaveAlt style={{ color: "#EF7000" }} {...props} ref={ref} />
    )),
  };
  const [isDownloadAllLoading, setIsDownloadAllLoading] = useState(false);
  const [isDownloadIndividual, setIsDownloadIndividual] = useState({
    isLoading: false,
    downloadingOption: "",
  });
  const handleDownloadAll = (event) => {
    setIsDownloadAllLoading(true);
    DataService.getDirectData("organisations/organsiation_data_download")
      .then((res) => {
        window.location.assign(res.file);
        dispatch(showSnackbar("success", ["Downloaded successfully "]));
      })
      .catch((error) => {
        dispatch(showSnackbar("error", ["No data found!"]));
      })
      .finally(() => {
        setIsDownloadAllLoading(false);
      });
  };

  const handleDownloadIndividual = (option) => {
    const { id: optionId, organisation_name: optionName } = option;
    setIsDownloadIndividual({
      isLoading: true,
      downloadingOption: optionId,
    });
    const params = { organisation_id: optionId };
    DataService.getDirectData(
      "organisations/organsiation_data_download",
      params
    )
      .then((res) => {
        window.location.assign(res.file);
        dispatch(
          showSnackbar("success", ["Downloaded successfully " + optionName])
        );
      })
      .catch((error) => {
        dispatch(showSnackbar("error", ["No data found!"]));
      })
      .finally(() => {
        setIsDownloadIndividual({ isLoading: false, downloadingOption: "" });
      });
  };
  return (
    <React.Fragment>
      <HeaderMenu />
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        style={{
          paddingTop: 30,
          paddingBottom: 30,
          paddingLeft: 80,
          paddingRight: 80,
        }}
      >
        <Grid item xs={6} style={{ textAlign: "left" }}>
          <Typography
            variant="h1"
            style={{ fontWeight: "bold", color: " #077F83" }}
          >
            All organizations
          </Typography>
        </Grid>
        <Grid item xs={6} style={{ textAlign: "right" }}>
          <Button
            disableElevation
            variant="contained"
            color="secondary"
            onClick={() => {
              dispatch({ type: DELETE_STEPPER_DATA });
              dispatch(ResetOrganisationDetails());
              dispatch(ResetActivity());
              dispatch(ResetBusinessDevelopment());
              dispatch(ResetContact());
              dispatch(ResetContract());
              dispatch(ResetGeneral());
              dispatch(ResetPreContract());
              dispatch(ResetProfile());
              history.push("/admin/organisation/create");
            }}
            style={{ textTransform: "none" }}
          >
            <AddCircleOutlined style={{ marginRight: 10, fontSize: 15 }} />
            Create organization
          </Button>
        </Grid>
      </Grid>
      <div className={classes.wrapper}>
        <Popper
          style={{ zIndex: "1500" }}
          open={open}
          anchorEl={anchorRef.current}
          role={undefined}
          transition
          disablePortal
        ></Popper>
        <InputBase
          fullWidth
          style={{
            height: 50,
            paddingLeft: 10,
            fontSize: "16px",
            fontFamily: "Open Sans",
          }}
          placeholder={"Search anything"}
          value={searchTextSelect}
          onChange={(e) => handleSearchText(e.target.value)}
          startAdornment={
            <InputAdornment position="start">
              <SearchIcon />
            </InputAdornment>
          }
        />
      </div>

      <div style={createOrganisationListLayout}>
        <Grid xs={12} sm={8}>
          {loading && <Loader />}
          <div className={classes.miTable}>
            <MaterialTable
              title={
                <Typography
                  variant="subtitle1"
                  style={{ fontWeight: "bold", color: "#EF7000" }}
                >
                  Organization
                </Typography>
              }
              icons={tableIcons}
              data={apiData}
              columns={columns}
              options={options}
              totalCount={totalCount}
              onChangePage={(page) => {
                setPage(page);
              }}
              localization={{
                toolbar: {
                  nRowsSelected: "{0} Organization selected",
                  exportAriaLabel: "Download as CSV ",
                  exportTitle: <TooltipWrapper text="Download as CSV" />,
                  exportName: "Download as CSV ",
                },
              }}
              onChangeRowsPerPage={(pageSize) => {
                setPageSize(pageSize);
              }}
              onSearchChange={(search) => {
                setSearchText(search);
              }}
              actions={[
                {
                  icon: () => {
                    return (
                      <Tooltip title={<TooltipWrapper text={"Live view"} />}>
                        <TableChartOutlinedIcon
                          style={{ height: "01.5rem" }}
                          color="secondary"
                        />
                      </Tooltip>
                    );
                  },
                  isFreeAction: true,
                  onClick: () => {
                    history.push({
                      pathname: "/admin/liveView/organisation",
                      state: { for: "organisation" },
                    });
                  },
                },
                {
                  icon: () => {
                    const params = {
                      page: page + 1 || 1,
                      count_per_page: pageSize || 20,
                      search_keyword: debouncedSearchText || null,
                    };

                    let url = "/organisations";
                    return (
                      <ExportSelector
                        params={params}
                        columns={columns}
                        url={url}
                        getDirectData
                        downloadKey="organisations"
                        fileName={"Organisation_listing"}
                        downloadText={"Download organisations listing"}
                        downloadingText={"Downloading organisations listing"}
                      />
                    );
                  },
                  isFreeAction: true,
                },
                {
                  icon: () => {
                    return (
                      <Tooltip
                        title={
                          <TooltipWrapper
                            text={
                              isDownloadAllLoading
                                ? "Downloading all records"
                                : "Download all records"
                            }
                          />
                        }
                      >
                        {isDownloadAllLoading ? (
                          <CircularProgress size={20} color="secondary" />
                        ) : (
                          <SaveAlt
                            style={{ height: "01.5rem" }}
                            color="secondary"
                          />
                        )}
                      </Tooltip>
                    );
                  },
                  isFreeAction: true,
                  onClick: handleDownloadAll,
                },
              ]}
            />
          </div>
        </Grid>
      </div>
    </React.Fragment>
  );
}
